<template>

  <button
    type="button"
    class="dropdown-item"
    @click="consentRequest">
    <i class="fas fa-stamp" /> {{ $t('Request consent') }}
    </button>

</template>

<script>
export default {
  name: 'JobActionMassConsetRequest',
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
    job () {
      return this.$store.getters.getJob
    },
    candidates () {
      return this.$store.getters.getCandidateSelected
    }
  },
  created () {
  },
  methods: {
    /*
    consentRequest
    */
    consentRequest () {
      this.candidates.forEach(candidate => {
        if (candidate.email) {
          this.$store.dispatch('requestConsent', {
            candidate_id: candidate._id
          })
        }
      })

      this.$store.dispatch('resetCandidateSelected')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobMassiveAction/JobMassiveActionConsentRequest.vue